import compose from 'lodash/flowRight'

import MarkAsExportedModal from './MarkAsExportedModal.component'
import { withBatchMarkAsExportedMutation } from './MarkAsExportedModal.mutations'

export default compose(withBatchMarkAsExportedMutation)(MarkAsExportedModal)
